"use strict";var $export=require("./_export"),$values=require("./_object-to-array")(!1);$export($export.S,"Object",{values:function(e){return $values(e)}});